import * as r from "react";
import { c as t } from "../createReactComponent-58f9bea8.mjs";
import { a as e, r as i } from "../link-7ef012bc.mjs";
import { L as g, T as L } from "../link-7ef012bc.mjs";
import "../property-9daa16cd.mjs";
import "../state-7560d4dc.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
import "../icon-c572aa57.mjs";
const l = t({ tagName: "ex-link", elementClass: e, react: r, events: { onClick: "click" }, displayName: "ExLink", registerWebComponent: i });
export {
  l as ExLink,
  g as LinkSize,
  L as TargetVariant,
  i as register
};
